import { Outlet } from 'react-router-dom';
import sahaLogo from '../../assets/logo-saha.svg';
import './Login.scss';

const AuthCardLayout = () => (
  <div className="login-page">
    <div className="login-card">
      <div className="login-card-content">
        <div className="login-logo-row">
          <img
            src={sahaLogo}
            alt="Saha Eğitim"
            style={{ width: 300, maxWidth: '100%', marginBottom: 16, marginTop: 16 }}
            className="register-logo"
          />
        </div>
        <Outlet />
      </div>
    </div>
  </div>
);

export default AuthCardLayout;
